export default {
  "ltv.title": "LTV",
  "ltv.column.no": "#NO",
  "ltv.column.statisticsTime": "Date",
  "ltv.column.registerNum": "Register Count",
  "ltv.column.ltv1": "LTV1",
  "ltv.column.ltv3": "LTV3",
  "ltv.column.ltv7": "LTV7",
  "ltv.column.ltv14": "LTV14",
  "ltv.column.ltv30": "LTV30",
  "ltv.search.statisticsTime": "Date",
};